import PrivacyConsent from "./PrivacyConsent";
import { PrivacyConsentEnum } from "./config";

// injected by 'rollup-plugin-version-injector'
PrivacyConsent.version = "[VI]{version} - {date}[/VI]";

window.PrivacyConsent = PrivacyConsent;
window.PrivacyConsentEnum = PrivacyConsentEnum;